import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class PartnerAnalysisGroup5 extends BaseEntity{

    partnerAnalysisGroup5Code : string;
    name : string;
    rank : number;
    
}

